import Icon from '../Icon/Icon';
import './Card.scss';

interface CardProps {
  id?: string;
  width?: string;
  maxWidth?: string;
  height?: string;
  minHeight?: string;
  full?: boolean;
  center?: boolean;
  sticky?: boolean;
  stickyTop?: number;
  disabled?: boolean;
  withLoader?: boolean;
  paddingVertical?: string;
  paddingHorizontal?: string;
  boxShadow?: string;
  children: React.ReactNode;
}

export default function Card({
  id,
  full,
  disabled,
  sticky,
  withLoader = false,
  ...props
}: CardProps) {
  return (
    <>
      <div
        id={id}
        className={
          'card ' +
          (full ? 'card-full' : '') +
          (disabled ? ' card-disabled' : '' + (sticky ? ' card-sticky' : ''))
        }
      >
        {props.children}
      </div>
      {withLoader && (
        <div className="sbt-loader-container">
          <Icon name="loader" />
        </div>
      )}
    </>
  );
}
